var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0786 4.90788C19.2707 3.64222 22.0739 4.39332 23.3395 6.58549C24.6052 8.77767 23.8541 11.5808 21.6619 12.8464L12.28 18.2631C10.0878 19.5288 7.28466 18.7777 6.01901 16.5855C4.75336 14.3933 5.50445 11.5902 7.69663 10.3245L17.0786 4.90788ZM21.8961 7.41883C21.0907 6.02381 19.3069 5.54584 17.9119 6.35125L8.52996 11.7679C7.13494 12.5733 6.65697 14.3571 7.46238 15.7522C8.2678 17.1472 10.0516 17.6251 11.4466 16.8197L20.8286 11.4031C22.2236 10.5977 22.7016 8.81385 21.8961 7.41883Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4956 5.62988C19.2892 4.59435 21.5826 5.20888 22.6182 7.00248C23.6537 8.79608 23.0392 11.0895 21.2456 12.1251L16.5546 14.8334L12.8046 8.33822L17.4956 5.62988Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0786 4.90788C19.2707 3.64223 22.0739 4.39332 23.3395 6.58549C24.6052 8.77767 23.8541 11.5808 21.6619 12.8464L16.2492 15.9714L11.6659 8.03288L17.0786 4.90788ZM21.8961 7.41883C21.0907 6.02381 19.3069 5.54584 17.9119 6.35125L13.9426 8.64292L16.8593 13.6947L20.8286 11.4031C22.2236 10.5977 22.7016 8.81385 21.8961 7.41883Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8657 30.4212C27.397 30.4212 29.4491 28.3692 29.4491 25.8379C29.4491 23.3066 27.397 21.2546 24.8657 21.2546C22.3344 21.2546 20.2824 23.3066 20.2824 25.8379C20.2824 28.3692 22.3344 30.4212 24.8657 30.4212ZM24.8657 32.0879C28.3175 32.0879 31.1157 29.2897 31.1157 25.8379C31.1157 22.3861 28.3175 19.5879 24.8657 19.5879C21.4139 19.5879 18.6157 22.3861 18.6157 25.8379C18.6157 29.2897 21.4139 32.0879 24.8657 32.0879Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8532 30.9454L21.4365 21.5635L22.8799 20.7301L28.2966 30.1121L26.8532 30.9454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.a583c5509711d53da29ec106dae4b37d.svg";
export { ForwardRef as ReactComponent };